var _templateObject;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { socials } from '../data';
var Container = styled.div.withConfig({
  displayName: "SocialContent__Container",
  componentId: "sc-2d65cj-0"
})(["display:flex;justify-content:", ";min-width:fit-content;margin-bottom:", ";", ";background-color:", ";color:", ";a{display:inline-block;opacity:0.8;margin-right:14px;color:", ";&:hover{opacity:1;}svg{width:", ";height:", ";}", "}a:last-child{margin-right:0;}"], function (_ref) {
  var big = _ref.big;
  return big ? 'space-evenly' : 'space-between';
}, function (_ref2) {
  var big = _ref2.big;
  return big ? '120px' : '40px';
}, maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["margin-bottom: 20px;"]))), function (_ref3) {
  var theme = _ref3.theme,
    transparent = _ref3.transparent;
  return transparent ? 'transparent' : theme.footerColor;
}, function (_ref4) {
  var transparent = _ref4.transparent,
    theme = _ref4.theme;
  return transparent ? theme.colors.primary : '#fff';
}, function (_ref5) {
  var transparent = _ref5.transparent,
    theme = _ref5.theme;
  return transparent ? theme.colors.primary : '#fff';
}, function (_ref6) {
  var big = _ref6.big;
  return big ? '48px' : '24px';
}, function (_ref7) {
  var big = _ref7.big;
  return big ? '48px' : '24px';
}, function (_ref8) {
  var transparent = _ref8.transparent,
    theme = _ref8.theme;
  return transparent && "\n        path {\n          fill: ".concat(theme.colors.primary, ";\n        }\n\n        .svg-stroke {\n          stroke: ").concat(theme.colors.primary, ";\n          fill: transparent;\n        }\n        ");
});
export var SocialContent = function SocialContent(_ref9) {
  var transparent = _ref9.transparent,
    big = _ref9.big;
  return React.createElement(Container, {
    transparent: transparent,
    big: big
  }, socials.map(function (social) {
    return React.createElement("a", {
      key: social.name,
      href: social.link,
      title: social.name,
      target: "_blank",
      rel: "noreferrer"
    }, social.icon);
  }));
};